import React from "react";
import { Link } from "@material-ui/core";
import { Trans } from "react-i18next";
import styled from "styled-components";

import { TermsOfUseAndRefundPolicy } from "../../components/TermsOfUseAndRefundPolicy/TermsOfUseAndRefundPolicy";

const StyledLink = styled(Link)`
    &&& {
        text-decoration: underline;
        color: #11a9e2;
        cursor: pointer;
    }
`;

type Props = {
    isAnnual: boolean;
    monthlyPrice: number;
    annualCostAtMonthlyRate: number;
    annualSavingsPercentage: number;
    onSwitchToMonthly: () => void;
    onSwitchToAnnual: () => void;
    includeTerms?: boolean;
    termsComponent?: React.ReactElement;
};

export function ProCheckoutBillingIntervalText({
    isAnnual,
    monthlyPrice,
    annualCostAtMonthlyRate,
    annualSavingsPercentage,
    onSwitchToMonthly,
    onSwitchToAnnual,
    includeTerms = false,
    termsComponent
}: Props) {
    const linkComponent = isAnnual
        ? <StyledLink onClick={onSwitchToMonthly} />
        : <StyledLink onClick={onSwitchToAnnual} />;

    const components: Record<string, React.ReactElement> = {
        billingIntervalLink: linkComponent
    };

    if (includeTerms) {
        components.terms = termsComponent ?? <TermsOfUseAndRefundPolicy textDecoration="none" />;
    }

    if (isAnnual) {
        return (
            <Trans
                i18nKey={includeTerms
                    ? "Pay ${{monthly}}/mo ({{annual}}/yr) when you <billingIntervalLink>switch to monthly billing</billingIntervalLink>. By continuing you agree to our <terms />"
                    : "Pay ${{monthly}}/mo ({{annual}}/yr) when you <billingIntervalLink>switch to monthly billing</billingIntervalLink>."
                }
                values={{ monthly: monthlyPrice, annual: annualCostAtMonthlyRate }}
                components={components}
            />
        );
    }

    return (
        <Trans
            i18nKey={includeTerms
                ? "Save {{savings}}% when you <billingIntervalLink>switch to annual billing</billingIntervalLink>. By continuing you agree to our <terms />"
                : "Save {{savings}}% when you <billingIntervalLink>switch to annual billing</billingIntervalLink>."
            }
            values={{ savings: annualSavingsPercentage.toFixed(0) }}
            components={components}
        />
    );
}
